var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FF7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7322 39.1426V33.3569H29.4107V40.589H22.1786C21.365 40.589 20.7322 39.9562 20.7322 39.1426ZM32.3036 40.589V33.3569H40.9822V39.1426C40.9822 39.9562 40.3042 40.589 39.5357 40.589H32.3036ZM40.9822 26.1247C41.7506 26.1247 42.4286 26.8027 42.4286 27.5711V31.1872C42.4286 31.594 42.067 31.9104 41.7054 31.9104H20.009C19.6022 31.9104 19.2857 31.594 19.2857 31.1872V27.5711C19.2857 26.8027 19.9186 26.1247 20.7322 26.1247H22.721C22.4046 25.5823 22.269 24.9947 22.269 24.3167C22.269 22.147 24.0318 20.339 26.2467 20.339C28.0999 20.339 29.3203 21.3334 30.9024 23.4579C32.4392 21.3334 33.6596 20.339 35.5581 20.339C37.7277 20.339 39.5357 22.147 39.5357 24.3167C39.5357 24.9947 39.3549 25.5823 39.0385 26.1247H40.9822ZM26.2015 26.1247H30.134C27.7835 22.6895 27.1055 22.5086 26.2015 22.5086C25.2071 22.5086 24.3935 23.3223 24.3935 24.3167C24.3935 25.3563 25.2071 26.1247 26.2015 26.1247ZM35.5581 26.1247C36.5525 26.1247 37.3661 25.3563 37.3661 24.3167C37.3661 23.3223 36.5525 22.5086 35.5581 22.5086C34.6089 22.5086 33.976 22.6895 31.6256 26.1247H35.5581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftOrange);
export default __webpack_public_path__ + "static/media/giftOrange.d64178b31ac6d3f4a890234aa60a18a2.svg";
export { ForwardRef as ReactComponent };